export const ACCOUNT_ID_PREFIX = "account";
export const RESIDENCE_ID_PREFIX = "residence";